import { createContext, useContext } from "react";
import type { MeResponse } from "@dm/shared";

export interface AppCtx {
  me: MeResponse;
  /** Re-read /api/me (after switching campaign, joining, settings changes). */
  reloadMe: () => Promise<MeResponse | null>;
  /** Show an error toast. */
  fail: (err: unknown) => void;
}

export const AppContext = createContext<AppCtx | null>(null);

export function useApp(): AppCtx {
  const a = useContext(AppContext);
  if (!a) throw new Error("useApp outside App");
  return a;
}
